import { render, staticRenderFns } from "./reminder-setting.vue?vue&type=template&id=5b2bd490"
import script from "./reminder-setting.vue?vue&type=script&lang=js"
export * from "./reminder-setting.vue?vue&type=script&lang=js"
import style0 from "./reminder-setting.vue?vue&type=style&index=0&id=5b2bd490&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports